import { Component } from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>'
})
export class DeviceTypeComponent {
}


// WEBPACK FOOTER //
// ./app/admin/devicetype/admin.devicetype.component.ts